import { ApiServiceV1 } from './api.service';

export const EnumsApiService = {
  async getEnums() {
    const { data } = await ApiServiceV1.get('enums');
    return data || {};
  },
};

export default EnumsApiService;
